import { render, staticRenderFns } from "./btnSet.vue?vue&type=template&id=3da5ca3b&scoped=true"
import script from "./btnSet.vue?vue&type=script&lang=js"
export * from "./btnSet.vue?vue&type=script&lang=js"
import style0 from "./btnSet.vue?vue&type=style&index=0&id=3da5ca3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5ca3b",
  null
  
)

export default component.exports